import * as Clipboard from 'expo-clipboard'
import Toast from 'react-native-toast-message'
import { vibrateError, vibrateSuccess } from '@/src/common/utils/vibrate'

export async function copyToClipboard(
  name: string,
  value: string,
  {
    bottomOffset = 88,
    position = 'bottom',
  }: Pick<Parameters<typeof Toast.show>[0], 'bottomOffset' | 'position'> = {},
) {
  try {
    Toast.hide()
    if (!(await Clipboard.setStringAsync(value))) throw new Error('Copy failed')
    Toast.show({
      text1: `${name} copied`,
      type: 'success',
      position,
      bottomOffset,
      onShow: () => void vibrateSuccess(),
    })
  } catch {
    Toast.hide()
    Toast.show({
      text1: `Failed to copy ${name}`,
      type: 'error',
      position,
      bottomOffset,
      onShow: () => void vibrateError(),
    })
  }
}
